import React, {useState ,useEffect} from 'react';
import axios from 'axios';
import { Box, Tab } from '@mui/material'
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';

const useStyles = makeStyles((theme)=>({
    companyInfoBlock:{
        padding:'300px 0 0 0',

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    row:{
        maxWidth:'1200px',
        margin:'0 auto',

        [theme.breakpoints.down(457)]: {
            maxWidth:'400px',
        }
    },
}))


const CompanyInfo = () => {

    const theme = useTheme();
    const classes = useStyles(theme);

    const [data, setData] = useState([])
    const [value, setValue] = useState('');

    const getItem = async() => {
        try {
            const res = await axios.get('/api/user/contentInfo/')

            if(res.data.success === false) {
                alert('불러오기 실패')
                return;
            }
            setData(res.data.result)
            setValue(res.data.result[0]['co_id'])
        
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        getItem()

        return () => {
            setData([])
            setValue('')
        }
    } ,[])


  return (
    <div className={classes.companyInfoBlock}>
        <div className={classes.row}>
            <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
                <Box 
                    sx={{ borderBottom: 1, borderColor: 'divider' }}                    
                >
                <TabList 
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }} 
                    aria-label="lab API tabs example"
                >
                    {data.length > 0 && data.map((itm) => (
                        <Tab 
                            key={itm['co_id']}
                            label={itm['co_subject']} 
                            value={itm['co_id']} 
                        />
                    ))}
                </TabList>
                </Box>
                {data.length > 0 && data.map((itm) => (
                    <TabPanel 
                        key={itm['co_id']}
                        value={itm['co_id']}
                    >
                        <div dangerouslySetInnerHTML={{__html: itm['co_content']}}/>
                    </TabPanel>
                ))}
                
            </TabContext>
            </Box>
        </div>
    </div>
  )
}

export default CompanyInfo
